<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section v-if="isDataFetched" class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">バナー登録・編集</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <!-- 検索条件 -->
      <div class="">
        <table style="width: 100%">
          <thead>
            <th style="width: 10%"></th>
            <th style="width: 25%"></th>
            <th style="width: 5%"></th>
            <th style="width: 55%"></th>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                バナーエリア
              </td>
              <td>
                <select
                  id="bannerArea"
                  class="form-control"
                  v-model="selectedBannerArea"
                  v-bind:disabled="!isSearchMode"
                >
                  <option
                    v-for="item in bannerAreaList"
                    :key="item.areaId"
                    :value="item.areaId"
                  >
                    {{ item.areaName }}
                  </option>
                </select>
              </td>
              <td class="form-control-title">
                <button
                  type="button"
                  name="btnSearch"
                  class="btn btn-primary"
                  @click="onSearch"
                  v-bind:disabled="!isSearchMode"
                >
                  検索
                </button>
              </td>
              <td>
                <button
                  type="button"
                  name="btnClearH"
                  class="btn btn-footer btn-primary"
                  @click="onClear"
                >
                  クリア
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <!-- 検索結果 -->
      <div class="">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th class="col_btnUpdate">編集</th>
              <th
                :class="[
                  'col_bannerName',
                  'sortable',
                  isDirectionASC('bannerName') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('bannerName')"
              >
                バナー名
              </th>
              <th class="col_caption">キャプション</th>
              <th class="col_bannerImg">バナー画像</th>
              <th class="col_linkUrl">リンクURL</th>
              <th
                :class="[
                  'col_hyoujiKIkan',
                  'sortable',
                  isDirectionASC('hyoujiKIkan') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('hyoujiKIkan')"
              >
                表示期間
              </th>
              <th
                :class="[
                  'col_hyoujiJun',
                  'sortable',
                  isDirectionASC('hyoujiJun') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('hyoujiJun')"
              >
                表示順
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in bannerDataList"
              :key="item.bannerId"
              :class="{ 'gray-background': isDispEnd(item.dispDtTo) }"
            >
              <td data-name="mSelection" style="text-align: center">
                <input
                  id="mSelection"
                  v-model="item.selection"
                  type="checkbox"
                  class="form-check-input"
                />
              </td>
              <td data-name="mBtnUpdate" style="text-align: center">
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  @click="showUpdate(item.bannerId)"
                >
                  編集
                </button>
              </td>
              <td data-name="mBannerName">{{ item.bannerName }}</td>
              <td data-name="mBannerCaption">{{ item.bannerCaption }}</td>
              <td>
                <img
                  v-if="item.bannerImgFileName"
                  class="col_imgCell"
                  :src="
                    appDir +
                    '/images/' +
                    item.bannerImgFileName +
                    '?v=' +
                    new Date().getTime()
                  "
                />
              </td>
              <td data-wrap data-name="mLinkUrl">
                {{ item.bannerUrl }}
              </td>
              <td style="text-align: center" data-name="mHyoujiKIkan">
                {{ formatDispDate(item.dispDtFrom) }} ～{{
                  formatDispDate(item.dispDtTo)
                }}
              </td>
              <td
                :class="{
                  'gray-background': isDispEnd(item.dispDtTo),
                  unchanged: !isDispEnd(item.dispDtTo),
                }"
                data-name="mHyoujiJun"
              >
                <NumericInput
                  :class="{
                    'gray-background': isDispEnd(item.dispDtTo),
                    unchanged: !isDispEnd(item.dispDtTo),
                  }"
                  style="
                    border: powderblue solid 1px;
                    text-align: center;
                    width: 100%;
                  "
                  v-model="item.dispOrder"
                  maxlength="3"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-inline flex-container">
          <div class="form-group">
            <button
              type="button"
              name="btnDelete"
              class="btn btn-footer btn-primary"
              @click="onDelete"
              v-bind:disabled="isSearchMode"
            >
              削除
            </button>
          </div>

          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="onBack"
            >
              戻る
            </button>

            <button
              type="button"
              name="btnClear"
              class="btn btn-footer btn-primary"
              @click="onClear"
            >
              クリア
            </button>
            <button
              type="button"
              name="btnUpdate"
              class="btn btn-footer btn-primary"
              @click="onUpdate"
              v-bind:disabled="isSearchMode"
            >
              更新
            </button>
            <button
              type="button"
              name="btnAdd"
              class="btn btn-footer btn-primary"
              @click="showAdd"
              v-bind:disabled="isSearchMode"
            >
              新規登録
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed, PropType } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  getTargetDate,
  scrollToTop,
  isTokenAlive,
  commonHandleAxiosError,
  formatDate,
  formatDispDate,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter, useRoute } from "vue-router";
import NumericInput from "../controls/NumericInput.vue";

interface BannerArea {
  areaId: string;
  areaName: string;
}

interface sortItem {
  key: string;
  direction: string;
}

interface bannerData {
  selection: boolean;
  bannerKbn: string;
  bannerId: string;
  bannerName: string;
  bannerCaption: string;
  bannerImgFileName: string;
  bannerUrl: string;
  dispOrder: number;
  dispDtFrom: string;
  dispDtTo: string;
}

class BannerListConstants {
  // ------------------------------------------------------------
  // バナー登録・変更 一覧画面の処理モード
  static readonly PROCESSING_MODE_SERACH = "SERACH"; // 検索条件入力
  static readonly PROCESSING_MODE_RESULT = "RESULT"; // 検索結果表示

  // ソート種別
  static readonly SORT_TYPE_ASC = "ASC"; // 昇順
  static readonly SORT_TYPE_DESC = "DESC"; // 降順

  static readonly API_URL_INITIAL_DISPLAY = "/api/BannerReg/getInitialData";
  static readonly API_URL_GET_BANNER = "/api/BannerReg/getBannerList";
  static readonly API_URL_DEL_BANNER = "/api/BannerReg/deleteBanner";
  static readonly API_URL_UPD_DISP_ORDER =
    "/api/BannerReg/updateBunnerDispOrder";
}

export default defineComponent({
  name: "BannerMaintenanceListComponent",
  props: {
    isResearch: {
      type: String as PropType<string>,
    },
  },
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    NumericInput,
  },
  computed: {
    isDispEnd(): (target: string) => boolean {
      return (target: string): boolean => {
        var dispEnd = formatDate(target);
        var systemDate = formatDate(getTargetDate(""));
        return dispEnd < systemDate;
      };
    },
  },
  setup() {
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const isResearch = computed(() => {
      return (
        route.query.isResearch &&
        String(route.query.isResearch).toLowerCase() === "true"
      );
    }); // 再検索フラグ
    const processingStore = useProcessingStore();
    const router = useRouter();
    const route = useRoute();
    const { logoutUser } = useUserStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const bannerAreaList = ref<BannerArea[]>([]); // バナーエリアリスト
    const bannerSortItemList = ref<sortItem[]>([]);
    const bannerDataList = ref<bannerData[]>([]);
    const processingMode = ref("");
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const selectedBannerArea = ref("");
    const appDir = process.env.VUE_APP_DIR;

    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
        }

        // 初期表示データ取得
        const response = await apiAuthClient.post(
          BannerListConstants.API_URL_INITIAL_DISPLAY,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
          }
        );

        bannerAreaList.value = response.data.initialDisplayData.bannerAreaList;

        // sessionStorageから検索条件復元
        if (isResearch.value) {
          const bannerKbn = sessionStorage.getItem(
            AppConstants.BANNER_SERCH_SESSION_NAME
          );
          if (bannerKbn) {
            // Sessionストレージに検索条件が設定されている場合は
            // Sessionストレージからバナーエリアを復元
            selectedBannerArea.value = bannerKbn;

            // バナー一覧を取得
            await getBannerList();
          }
        } else {
          // 一番最初（カルーセル）を選択状態にする
          selectedBannerArea.value = bannerAreaList.value[0].areaId;
          processingMode.value = BannerListConstants.PROCESSING_MODE_SERACH;
          // バナー一覧を取得
          //await getBannerList();
        }

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * バナー一覧取得
     */
    const getBannerList = async () => {
      const response = await apiAuthClient.post(
        BannerListConstants.API_URL_GET_BANNER,
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          bannerKbn: selectedBannerArea.value,
        }
      );

      // 検索条件をsessionStorageに保存
      sessionStorage.setItem(
        AppConstants.BANNER_SERCH_SESSION_NAME,
        selectedBannerArea.value
      );

      // レスポンスを保持
      bannerDataList.value = response.data.bannerDataList;
      // 処理モード設定
      processingMode.value = BannerListConstants.PROCESSING_MODE_RESULT;
      // ソート状態を保持
      bannerSortItemList.value = getSortItemListDef();

      // 一番上にスクロール
      scrollToTop();
    };

    /**
     * 更新チェック処理
     */
    const validateInput = (): boolean => {
      bannerDataList.value.forEach((banner) => {
        outputDebugLogs("banner.dispOrder: " + banner.dispOrder);
        if (!banner.dispOrder) {
          errorMessage.value = formatMessage(messages.ERR_0001, "表示順");
        }
      });

      if (errorMessage.value == "") {
        return true;
      } else {
        return false;
      }
    };

    /**
     * 検索ボタン押下
     */
    const onSearch = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 入力チエック

      // 処理中フラグON
      processingStore.isProcessing = true;

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // バナー一覧情報取得
      try {
        await getBannerList();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 削除ボタン押下
     */
    const onDelete = async () => {
      if (processingStore.isProcessing) {
        return;
      }
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 削除対象絞り込み
        const targetList = bannerDataList.value.filter(
          (bannerData) => bannerData.selection
        );

        // メッセージクリア
        errorMessage.value = "";
        // 選択件数チェック
        if (targetList.length < 1) {
          errorMessage.value = formatMessage(messages.ERR_0003, "明細");

          // 一番上にスクロール
          scrollToTop();

          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "バナー", "削除")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        await apiAuthClient.post(BannerListConstants.API_URL_DEL_BANNER, {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          bannerList: targetList,
        });

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "バナー", "削除"));

        // バナー一覧情報取得
        await getBannerList();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      // 管理者トップへ遷移
      router.push("/kanrisya-top");
    };

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        // メッセージクリア
        errorMessage.value = "";

        if (!isSearchMode.value) {
          // 検索結果表示モードの場合

          // 検索結果クリア
          bannerDataList.value = [];

          selectedBannerArea.value = bannerAreaList.value[0].areaId;

          // 検索条件入力モードを設定
          processingMode.value = BannerListConstants.PROCESSING_MODE_SERACH;

          // 一番上にスクロール
          scrollToTop();
        } else {
          // 検索条件入力モードの場合
          selectedBannerArea.value = bannerAreaList.value[0].areaId;
        }
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 更新ボタン押下
     */
    const onUpdate = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // 入力チェック
        if (!validateInput()) {
          outputDebugLogs("errorMessage.value: " + errorMessage.value);
          // 一番上にスクロール
          scrollToTop();
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "バナー表示順", "更新")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // AGセグメント更新
        try {
          // API呼出し
          await apiAuthClient.post(BannerListConstants.API_URL_UPD_DISP_ORDER, {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            bannerDataList: bannerDataList.value,
          });

          // 完了メッセージ表示
          alert(formatMessage(messages.INF_0001, "バナー表示順", "更新"));

          // バナー一覧情報取得
          await getBannerList();
        } catch (error: unknown) {
          // エラー処理
          handleAxiosError(error);
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 新規登録ボタン押下
     */
    const showAdd = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 検索条件(バナー区分)をsessionStorageに保存
        sessionStorage.setItem(
          AppConstants.BANNER_SERCH_SESSION_NAME,
          selectedBannerArea.value
        );

        // バナー登録・変更 登録画面へ遷移
        router.push({
          path: "/banner-touroku",
          query: {
            bannerKbn: selectedBannerArea.value,
            bannerId: "",
            editMode: AppConstants.CONTENTS_EDIT_MODE_NEW,
          },
        });
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 編集ボタン押下
     * @param bannerId バナーID
     */
    const showUpdate = (bannerId: string) => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 検索条件(バナー区分)をsessionStorageに保存
        sessionStorage.setItem(
          AppConstants.BANNER_SERCH_SESSION_NAME,
          selectedBannerArea.value
        );

        // バナー登録・変更 更新画面へ遷移
        router.push({
          path: "/banner-touroku",
          query: {
            bannerKbn: selectedBannerArea.value,
            bannerId: bannerId,
            editMode: AppConstants.CONTENTS_EDIT_MODE_UPDATE,
          },
        });
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * ソート順が昇順か判定します。
     * @param key ソート項目
     */
    const isDirectionASC = (key: string): boolean => {
      const sortItem = bannerSortItemList.value.find(
        (sortItem) => sortItem.key == key
      );
      if (sortItem && sortItem.direction == BannerListConstants.SORT_TYPE_ASC) {
        return true;
      }
      return false;
    };

    /**
     * 検索条件入力モード判定
     */
    const isSearchMode = computed(() => {
      return processingMode.value == BannerListConstants.PROCESSING_MODE_SERACH;
    });

    /**
     * 検索結果のソート処理を行います。
     * @param key ソート項目
     */
    const onSortItem = (key: string) => {
      bannerSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          switch (sortItem.key) {
            case "bannerName":
              if (sortItem.direction == BannerListConstants.SORT_TYPE_ASC) {
                // 降順
                bannerDataList.value.sort((a, b) =>
                  b.bannerName.localeCompare(a.bannerName)
                );
              } else {
                // 昇順
                bannerDataList.value.sort((a, b) =>
                  a.bannerName.localeCompare(b.bannerName)
                );
              }
              break;
            case "hyoujiKIkan":
              if (sortItem.direction == BannerListConstants.SORT_TYPE_ASC) {
                // 降順
                bannerDataList.value.sort((a, b) =>
                  b.dispDtFrom.localeCompare(a.dispDtFrom)
                );
              } else {
                // 昇順
                bannerDataList.value.sort((a, b) =>
                  a.dispDtFrom.localeCompare(b.dispDtFrom)
                );
              }
              break;
            case "hyoujiJun":
              if (sortItem.direction == BannerListConstants.SORT_TYPE_ASC) {
                // 昇順
                bannerDataList.value.sort((a, b) => a.dispOrder - b.dispOrder);
              } else {
                // 降順
                bannerDataList.value.sort((a, b) => b.dispOrder - a.dispOrder);
              }
              break;
          }

          if (sortItem.direction == BannerListConstants.SORT_TYPE_ASC) {
            sortItem.direction = BannerListConstants.SORT_TYPE_DESC;
          } else {
            sortItem.direction = BannerListConstants.SORT_TYPE_ASC;
          }
        }
      });
    };

    /**
     * ソート項目の初期値を返却します。
     */
    const getSortItemListDef = () => {
      return [
        {
          key: "bannerName",
          direction: BannerListConstants.SORT_TYPE_DESC,
        },
        {
          key: "hyoujiKIkan",
          direction: BannerListConstants.SORT_TYPE_ASC,
        },
        {
          key: "hyoujiJun",
          direction: BannerListConstants.SORT_TYPE_DESC,
        },
      ];
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      bannerAreaList,
      onSearch,
      isDirectionASC,
      onSortItem,
      isSearchMode,
      onDelete,
      onBack,
      onClear,
      showAdd,
      selectedBannerArea,
      bannerDataList,
      showUpdate,
      onUpdate,
      formatDispDate,
      appDir,
    };
  },
});
</script>

<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
/* 折り返し表示用スタイル */
td[data-wrap] {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 0; /* 必要に応じて幅を設定 */
}
.col_selection {
  width: 4%;
}
.col_btnUpdate {
  width: 5%;
}
.col_bannerName {
  width: 18%;
}
.col_caption {
  width: 15%;
}
.col_bannerImg {
  width: 12%;
}
.col_linkUrl {
  width: 21%;
}
.col_hyoujiKIkan {
  width: 18%;
}
.col_hyoujiJun {
  width: 7%;
}
.col_imgCell {
  margin-top: 5px;
  margin-bottom: 5px;
}
.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
}
.sortable::after {
  content: "";
  position: absolute;
  right: 5px;
}
.sortable.asc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: 0.1em 0 0 0.6em;
  transform: rotate(-135deg);
  vertical-align: middle;
  width: 8px;
}
.sortable.desc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: -0.5em 0 0 0.6em;
  transform: rotate(45deg);
  vertical-align: middle;
  width: 8px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  vertical-align: middle;
}
.form-control-title {
  text-align: left;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.gray-background {
  background-color: rgb(177, 177, 177);
}
.unchanged {
  background-color: #fffdbf;
}
</style>
